export default __webpack_public_path__ + "static/media/google-logo.6b933c79.svg";